import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["actionContainer", "progressContainer"]


  connect() {
    console.log("DpagreementController connected")
  }

  acceptAgreement(event) {
    console.log("Accept Agreement clicked")
    const container = this.element.querySelector('[data-dpagreement-target="actionContainer"]')
    container.classList.add('d-none');
    const progressContainer = this.element.querySelector('[data-dpagreement-target="progressContainer"]')
    progressContainer.classList.remove('d-none');
    // event.preventDefault()
  }

}